import { all, fork, call, put, takeLatest } from 'redux-saga/effects';
import {
  Types as NotaFiscalParticipantTypes,
  Creators as NotaFiscalParticipantActions,
} from '../ducks/NotaFiscalParticipant';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getNotasParticipant({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/participant-invoices', {
      params: payload,
    });
    if (status === 200) {
      yield put(NotaFiscalParticipantActions.getNotasParticipantSuccess(data));
    } else {
      Sentry.captureMessage('getNotasParticipant failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(NotaFiscalParticipantActions.getNotasParticipantError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalParticipantActions.getNotasParticipantError());
  }
}

function* getNotaParticipantById({ payload }) {
  const { id } = payload;
  try {
    const { status, data } = yield call(api.get, `/participant-invoices/${id}`);
    if (status === 200) {
      yield put(NotaFiscalParticipantActions.getNotaParticipantByIdSuccess(data));
    } else {
      Sentry.captureMessage('getNotaParticipantById failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(NotaFiscalParticipantActions.getNotaParticipantByIdError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalParticipantActions.getNotaParticipantByIdError());
  }
}

function* putNotasParticipant({ payload }) {
  const { id, data } = payload;
  try {
    const { status } = yield call(api.put, `/participant-invoices/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (status === 200) {
      yield put(NotaFiscalParticipantActions.putNotasParticipantSuccess());
    } else {
      Sentry.captureMessage('putNotasParticipant failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(NotaFiscalParticipantActions.putNotasParticipantError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalParticipantActions.putNotasParticipantError());
  }
}

function* paidNotasParticipant({ payload }) {
  try {
    const { status } = yield call(api.post, `/participant-invoices/${payload}/pay`);
    if (status === 200) {
      yield put(NotaFiscalParticipantActions.paidNotasParticipantSuccess());
    } else {
      Sentry.captureMessage('paidNotasParticipant failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(NotaFiscalParticipantActions.paidNotasParticipantError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalParticipantActions.paidNotasParticipantError());
  }
}

function* receiptParticipantUpload({ payload }) {
  const { id, data } = payload;
  try {
    const { status } = yield call(api.post, `/participant-invoices/${id}/receipt`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (status === 200) {
      yield put(NotaFiscalParticipantActions.receiptParticipantUploadSuccess());
    } else {
      Sentry.captureMessage('receiptParticipantUpload failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(NotaFiscalParticipantActions.receiptParticipantUploadError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(NotaFiscalParticipantActions.receiptParticipantUploadError(error.response));
  }
}

function* getNotasWatcher() {
  yield takeLatest(NotaFiscalParticipantTypes.GET_NOTA_PARTICIPANT, getNotasParticipant);
}

function* getNotaByIdWatcher() {
  yield takeLatest(NotaFiscalParticipantTypes.GET_NOTA_PARTICIPANT_BY_ID, getNotaParticipantById);
}

function* putNotasWatcher() {
  yield takeLatest(NotaFiscalParticipantTypes.PUT_NOTA_PARTICIPANT, putNotasParticipant);
}

function* paidNotasWatcher() {
  yield takeLatest(NotaFiscalParticipantTypes.PAID_NOTA_PARTICIPANT, paidNotasParticipant);
}

function* receiptUploadWatcher() {
  yield takeLatest(NotaFiscalParticipantTypes.RECEIPT_PARTICIPANT_UPLOAD, receiptParticipantUpload);
}

export default function* rootSaga() {
  yield all([
    fork(getNotasWatcher),
    fork(getNotaByIdWatcher),
    fork(putNotasWatcher),
    fork(paidNotasWatcher),
    fork(receiptUploadWatcher),
  ]);
}
